import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CheckinCard from '../components/CheckinCard';
import { DriverCheckin } from '../types';
import { History } from '@mui/icons-material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface HistoryTabProps {
  history: DriverCheckin[];
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  fetchHistory: (date?: Date | null) => void;
}


const HistoryTab: React.FC<HistoryTabProps> = ({ history, selectedDate, setSelectedDate, fetchHistory }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' }, // Empilha em XS, lado a lado em SM+
          alignItems: { xs: 'flex-start', sm: 'center' }, // Alinha à esquerda em XS
          justifyContent: 'space-between',
          ml: { xs: 1, sm: 3 }, // Reduz a margem em XS
          mr: { xs: 1, sm: 0 },
          mb: 3,
          width: '98%', // Ajusta a largura
          gap: 2, // Espaçamento entre os elementos
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
          <History /> Histórico de Atendimentos ({history.length})
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Filtrar por data"
            value={selectedDate}
            sx={{ width: { xs: '100%', sm: 'auto' } }} // Largura total em XS

            onChange={(newDate) => {
              setSelectedDate(newDate);
              fetchHistory(newDate || null);
            }}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            slotProps={{
              textField: { size: 'small', inputProps: { readOnly: true }, onClick: () => setOpen(true) },
              openPickerButton: { onClick: () => setOpen(true) },
            }}
          />

        </LocalizationProvider>
      </Box>

      {history.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            Nenhum atendimento finalizado ou cancelado
          </Typography>
        </Box>
      ) : (
        history.map((driver) => (
          <CheckinCard
            key={driver.id}
            driver={driver}
            actionLoading={null}
            onFinish={() => { }}
            onCancel={() => { }}
          />
        ))
      )}
    </>
  );
};

export default HistoryTab;


